export default "__VITE_ASSET__BDilnvJc__"